import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { StyledActionIcon } from "src/styled";

export const BackButton = () => {
  const navigate = useNavigate();

  return (
    <StyledActionIcon
      data-cy="back-button"
      size="lg"
      onClick={() => navigate(-1)}>
      <IconChevronLeft size="1.5rem" />
    </StyledActionIcon>
  );
};
